import { Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ISelectOption } from '../../models/utils/selectOption'
import { defaultFilterOption } from '../../utils'
import { useGetDataOnScroll } from '../getDataOnScrollProps/useGetDataOnScrollProps'
import { EntInitialFilterName } from '../../models/filters/initialFilterName'
import { getCookie } from 'typescript-cookie'
import { EntDirectoryInfoName } from '../../models/directoryInfoName'
import { useLazyGetQuestionCategoryListQuery } from '../../redux/api/handBooksApi/kurultai/questionCategoryApi'

interface IProps {
	multiple?: boolean
	value?: number | number[] | null
	onChange?: (v: number | number[]) => void
	status?: any
}

const SelectQuestionType = (props: IProps) => {
	const { t } = useTranslation()
	const language = getCookie('i18next')
	const [options, setOptions] = useState<ISelectOption[]>([])

	const [getData] = useLazyGetQuestionCategoryListQuery()
	const { fetching, data, setData, setFetching, setFilter, scrollHandler, setCurrentPage } =
		useGetDataOnScroll<EntDirectoryInfoName, EntInitialFilterName>({
			initialFilter: new EntInitialFilterName(),
			query: getData,
		})

	useEffect(() => {
		const uniqueOptions = Array.from(new Map(data.map(a => [a.id, a])).values()).map(a => ({
			label: language === 'ky' ? a.nameKy : a.nameRu,
			value: a.id,
		}))

		setOptions(uniqueOptions)
	}, [data, language])

	const search = (e: any) => {
		const filter = new EntInitialFilterName()
		filter.name = e.target.value
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const clear = () => {
		const filter = new EntInitialFilterName()
		filter.name = null
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const selectMode = props.multiple ? 'multiple' : undefined

	let selectValue: number | number[] | undefined
	if (props.value == null) {
		selectValue = undefined
	} else if (Array.isArray(props.value)) {
		selectValue = Array.from(new Set(props.value))
	} else {
		selectValue = props.value
	}

	return (
		<Select
			mode={selectMode}
			placeholder={t('msg.selectPlaceholder')}
			onClear={clear}
			onInputKeyDown={search}
			onPopupScroll={scrollHandler}
			loading={fetching}
			value={selectValue}
			onChange={vals => {
				if (props.multiple) {
					const uniqueVals = Array.from(new Set(vals as number[]))
					props.onChange?.(uniqueVals)
				} else {
					props.onChange?.(Number(vals))
				}
			}}
			options={options}
			filterOption={defaultFilterOption}
			showSearch
			allowClear
			dropdownRender={menu => <Spin spinning={fetching}>{menu}</Spin>}
			status={props.status}
		/>
	)
}

export default SelectQuestionType
